import Request from './request'

export default class PaymentService {
  static async getPaymentQRMethod(data) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: 'POST',
        path: '/PartnerAPI/PaymentQR/user/getPublicPaymentMethod',
        data: data,
        token: false
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(data)
        } else {
          // Trả về cả result để FE biết có phải lỗi mạng không (result.isNetworkError)
          return reject(result)
        }
      })
    })
  }

  static async calculatePaymentInfo(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/PartnerAPI/Order/user/calculatePaymentInfo',
        data: data
      }).then((result = {}) => {
        const { statusCode } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          // result đã bao gồm isNetworkError nếu là lỗi mạng
          return resolve(result)
        }
      })
    })
  }
}
